/*
 * @Date: 2022-07-05 20:05:13
 * @LastEditors: chuhongguang
 * @desc: ESG
 */
import DefaultLayout from '@/layout/index'
const baseLangKey = 'layout.headerBar';

export default   {
  name: 'esg',
  path: '/esg',
  redirect: '/esg/index',
  component: DefaultLayout,
  children: (pre => [
    {
      path: 'index',
      name: `${pre}index`,
      meta: {
        title: '环境、社会及管治',
        langKey: baseLangKey + '.esg'
      },
      component: () => import('@/views/esg/index.vue')
    },
  ])('esg-')
}